/** Total digits a bank code holds, e.g. 6 for both a UK sort code and an AU BSB. */
function bankCodeDigitCount(groupSizes: readonly number[]): number {
  return groupSizes.reduce((total, size) => total + size, 0);
}

/** Length of the formatted value including separators, used as the input's maxLength. */
function bankCodeMaxLength(groupSizes: readonly number[]): number {
  return bankCodeDigitCount(groupSizes) + Math.max(groupSizes.length - 1, 0);
}

/**
 * Strips non-digits, caps at the configured digit count, and joins the digit groups with hyphens for
 * display, so `[2, 2, 2]` renders a UK sort code as xx-xx-xx and `[3, 3]` renders an AU BSB as xxx-xxx.
 */
function formatBankCode(raw: string, groupSizes: readonly number[]): string {
  const digits = raw.replace(/\D/g, '').slice(0, bankCodeDigitCount(groupSizes));
  const groups: string[] = [];
  let offset = 0;

  for (const size of groupSizes) {
    if (offset >= digits.length) break;
    groups.push(digits.slice(offset, offset + size));
    offset += size;
  }

  return groups.join('-');
}

/**
 * Returns the caret index in a formatted bank code immediately after the Nth digit,
 * so typing and editing keep the cursor aligned with digit groups (e.g. xx-xx-xx).
 */
function caretPositionAfterDigitCount(formatted: string, digitsBefore: number): number {
  if (digitsBefore <= 0) return 0;
  let digits = 0;
  let pos = formatted.length;
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted.charAt(i))) digits += 1;
    if (digits === digitsBefore) {
      pos = i + 1;
      break;
    }
  }
  return pos;
}

export { bankCodeDigitCount, bankCodeMaxLength, caretPositionAfterDigitCount, formatBankCode };
